import React, {useRef} from 'react';
import clamp from 'lodash-es/clamp'
import { useSprings, animated } from 'react-spring'
import { useGesture } from 'react-with-gesture'

interface Props {
    pages: any[];
    width: number | string;
}

const Pager: React.FC<Props> = ({pages, width}) => {
    const index = useRef(0);
    console.log(window.innerHeight)
    const [props, set] = useSprings(pages.length, i => ({ x: i * window.innerWidth, sc: window.innerHeight < 600 ? 0.6 : 1 , display: 'block' }))
    const bind = useGesture(({ down, delta: [xDelta], direction: [xDir], distance, cancel }) => {
        if (down && distance > window.innerWidth / 4 && cancel !== undefined) {
            // @ts-ignore
            cancel((index.current = clamp(index.current + (xDir > 0 ? -1 : 1), 0, pages.length - 1)));
        }
        // @ts-ignore
        set((i: number) => {
            if (i < index.current - 1 && i > index.current + 1) return { display: 'none' };
            const x = (i - index.current) * window.innerWidth + (down ? xDelta : 0);
            const sc = down ? 1 - distance / window.innerWidth / 2 : 1;
            return { x, sc, display: 'block' }
        })
    });
    const isSmall = window.innerHeight < 600
    return (
        <div style={
            {
                position: 'relative',
                willChange: 'transform',
                width: width,
            }
        }>
            {props.map(({ x, display, sc }, i) => (
                <animated.div {...bind()} key={i} style={
                    {
                        width: '100%',
                        height: '100%',
                        willChange: 'transform',
                        position: 'absolute',
                        display,
                        transform: x.interpolate(x => `translate3d(${x}px,0,0)`) }}>
                    <animated.div style={{ transform: sc.interpolate(s => `scale(${isSmall ? s-0.1 : s})`), transformOrigin: 'top' }}>
                        {pages[i]}
                    </animated.div>
                </animated.div>
            ))}
        </div>
    )
};

export default Pager;